module.exports = __webpack_public_path__ + "img/photo-0069.b00cbc5f.jpg";